module.exports = __webpack_public_path__ + "static/media/vibino-feature-photo effect-PIC3.808da353.jpg";